import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconWebinar = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 22 22"
      data-fill-none
    >
      <path
        d="M17.4999 3.8125H4.91332C3.92026 3.8125 3.11523 4.61753 3.11523 5.61058V18.1972C3.11523 19.1902 3.92026 19.9953 4.91332 19.9953H17.4999C18.493 19.9953 19.298 19.1902 19.298 18.1972V5.61058C19.298 4.61753 18.493 3.8125 17.4999 3.8125Z"
        stroke="currentColor"
        strokeWidth="1.07885"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8027 2.01953V5.6157"
        stroke="currentColor"
        strokeWidth="1.07885"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.60938 2.01953V5.6157"
        stroke="currentColor"
        strokeWidth="1.07885"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.11523 9.20703H19.298"
        stroke="currentColor"
        strokeWidth="1.07885"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);
